<template>
  <div :class="$style.container">
    <fpneko :class="$style.image" />
    <p :class="[$style.container__text, $style.text]">
      <template v-if="isSuccessed">
        クレジットカードの情報の変更が完了しました。{{
          usageMonthString
        }}月利用分({{ invoiceMonthString }}月請求)から変更されます。
      </template>
      <template v-else>キャンセルされました。</template><br />
      ブラウザの閉じるボタンを押して、このページを閉じてください。
    </p>
  </div>
</template>

<script setup lang="ts">
import fpneko from '@/assets/images/fpneko.svg?component'
import { getQuery } from '@/libs/utilities/getQuery'
import { useRoute } from 'vue-router'
import { format, addMonths } from 'date-fns'

const route = useRoute('stripeCallback')

const isSuccessed = getQuery(route.query.success) === 'true'

const now = new Date()

const usageMonthString = format(now, 'M')
// 請求処理前後(月初~9日)は請求情報の更新ができなくなっているので、処理中のことは考えなくて良い
const invoiceMonthString = format(addMonths(now, 1), 'M')
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__text {
    margin-top: 40px;
    text-align: center;
  }
}

.image {
  width: 200px;
}

.text {
  font-size: 20px;
  font-weight: bold;
}
</style>
